import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=12d981ca&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
import style0 from "./Edit.vue?vue&type=style&index=0&id=12d981ca&prod&lang=scss&scoped=true"
import style1 from "./Edit.vue?vue&type=style&index=1&id=12d981ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d981ca",
  null
  
)

export default component.exports